export const SEARCH_META_TITLE = 'Office Space for Rent | Find Offices';
export const SEARCH_META_DESCRIPTION =
  'Browse available office spaces for rent in  New York City, NY and San Francisco Bay Area. Find a fully furnished office rental for your business with Codi.';
